export default __webpack_public_path__ + "static/media/chevron-down.6f12754a.svg";